import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product } from '../../../models/product';

@Component({
  selector: 'app-product-location',
  imports: [RouterModule],
  templateUrl: './product-location.html',
  styleUrl: './product-location.scss',
})
export class ProductLocation {
  @Input({ required: true }) product!: Product;
}
